import AdminDashboardView from "@/views/admin/dashboard/DashboardView";

export default [
  {
    name: "pages.admin.dashboard",
    path: "dashboard",
    component: AdminDashboardView
  },
  
];
